module.exports = __webpack_public_path__ + "static/media/Purple360Desktop.8abd1987.svg";